export default __webpack_public_path__ + "static/media/logo.546277f2.svg";